import type { HomepagePageData, HomepagePageUserData } from 'src/app/pages/homepageV2/pageContext';
import { useHomepagePageData, useHomepagePageUserData } from 'src/app/pages/homepageV2/pageContext';

type Result = ModelHookResult<
	HomepagePageUserData & {
		trendingPetitions: HomepagePageData['trendingPetitions'];
		trendingTopics: HomepagePageData['trendingTopics'];
	}
>;

export function usePageBody(): Result {
	const {
		data: { trendingPetitions, trendingTopics },
	} = useHomepagePageData();

	const {
		data: { showV3, showHowToV3, showSunrise },
	} = useHomepagePageUserData();

	return {
		data: {
			trendingPetitions,
			trendingTopics,
			showV3,
			showHowToV3,
			showSunrise,
		},
	};
}
